<template>
  <v-autocomplete
    v-bind="$attrs"
    ref="field"
    v-model="localValue"
    :items="items"
    :loading="loading"
    no-filter
    :clearable="clearable && !$attrs.readonly && $attrs.readonly !== ''"
    :search-input.sync="match"
    hide-selected
    @change="onChange"
    @focus="(e) => e.target.click()"
  >
    <template #selection="data">
      <v-chip
        color="white"
        :selected="data.selected"
        class="chip--select-multi"
        :close="$attrs.multiple"
        @input="removeItem(data.item)"
      >
        <v-avatar>
          <img :src="data.item.logo" />
        </v-avatar>
        {{ data.item.text }}
      </v-chip>
    </template>
    <template #item="data">
      <v-list-tile-avatar>
        <img :src="data.item.logo" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="data.item.text" />
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'debounce'
export default {
  name: 'EntityField',
  props: {
    value: {
      type: [String, Array],
      required: false,
      default: '',
    },
    tournamentId: {
      type: String,
      required: false,
      default: '',
    },
    isCustomer: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    hideItems: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterData: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      match: '',
      itemList: [],
      cacheList: [],
      loading: false,
      init: false,
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    items() {
      return this.itemList
    },
  },
  watch: {
    value(val) {
      if (!val.length) this.$emit('changeObjects', [])
    },
    match() {
      this.fetch()
    },
    tournamentId() {
      this.fetch()
    },
    isCustomer() {
      this.fetch()
    },
  },
  created() {
    this.fetch = debounce(function () {
      if (this.$refs.field && this.value !== this.$refs.field.lazyValue)
        this.$refs.field.lazyValue = this.value

      let params = { set: false }
      if (this.localValue && !Array.isArray(this.localValue)) {
        params._id = this.localValue
      } else if (
        Array.isArray(this.localValue) &&
        this.localValue.length &&
        !this.init
      ) {
        params._id = this.localValue
      } else {
        if (this.tournamentId) params.tournamentId = this.tournamentId
        if (this.match) params.match = this.match
        if (this.isCustomer) params.isCustomer = this.isCustomer
      }
      if (this.filterData) params.fetchData = true
      this.loading = true
      this.$store
        .dispatch('entities/fetchSelectList', params)
        .then((list) => {
          this.itemList = []
          list.forEach((item) => {
            this.itemList.push(item)
          })
          if (
            !Array.isArray(this.value) &&
            !this.itemList.some((item) => item.value === this.value)
          )
            this.value = ''
          if (this.localValue.length) this.onChange(this.localValue)
          this.setCache()
        })
        .finally(() => {
          this.loading = false
          this.init = true
        })
    }, 700)
    this.fetch()
  },
  methods: {
    fetch() {},
    onChange(val) {
      this.$emit('change', val)
      this.$emit(
        'changeObjects',
        val ? this.itemList.filter((item) => val.includes(item.value)) : []
      )
      this.$emit('update:teams')
    },
    setCache() {
      if (Array.isArray(this.localValue)) {
        this.localValue.forEach((v) => {
          const isCached = this.cacheList.some((item) => item.value === v)
          if (!isCached) {
            let item = this.itemList.find((item) => item.value === v)
            if (item) {
              this.cacheList.push(item)
            }
          }
        })
        this.cacheList = this.cacheList.filter((item) =>
          this.localValue.includes(item.value)
        )
        this.cacheList.forEach((cacheItem) => {
          const inList = this.itemList.some(
            (listItem) => listItem.value === cacheItem.value
          )
          if (!inList) this.itemList.push(cacheItem)
        })
      }
    },
    removeItem(item) {
      if (Array.isArray(this.localValue)) {
        const index = this.localValue.indexOf(item.value)
        if (index >= 0) this.localValue.splice(index, 1)
      } else this.localValue = ''
    },
  },
}
</script>
